<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>

        <!-- <Spinner ref="spinner"></Spinner> -->
<div class="mb-4"><zigZag></zigZag></div>
        <v-layout text-xs-center mt-5>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-0 align-center>
              
              <v-flex >
                <v-layout row >
                  <v-icon class="mr-2">fa-plus-circle</v-icon>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Create New Batch</div>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-flex class= "xs12 mx-2" style="margin-bottom:0!important;">
              

              <v-form v-model="valid" @submit="createBatch" ref="createBatchForm" mb-0>

                    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2 mb-0>
                      <v-layout hide-details justify-start row mt-0 mb-0 >

                         <v-flex hide-details mx-4 xs5>
                       
                        <v-autocomplete
                          :items="ddlBatchType"
                          v-model="batch.type"
                          item-text="Text"
                          item-value="Value"
                          label="Batch Type*"
                          required
                          :rules="requiredRules"
                          @change="getBatchDescription"
                        ></v-autocomplete>
                      </v-flex>
                     <v-flex mx-4 xs5>
                        <v-autocomplete
                          :items="ddlBatchDescription"
                          v-model="batch.description"
                          item-text="Text"
                          item-value="Value"
                          label="Batch Description*"
                          :disabled="batch.type == null || typeof batch.type == undefined ? true: false"
                          :rules="requiredRules"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex mx-4 xs3>
                      </v-flex>
                      <v-flex mx-4 xs1>
                         <v-btn
                        color="success"
                        @click="createBatch"
                        class="ml-2 mr-4"
                      >
                        Create New
                      </v-btn>
                      </v-flex>
                      </v-layout>
                    </v-layout>
              </v-form>
            </v-flex>
</v-flex>
        </v-layout>

    </v-card>
  </v-flex>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import axios from "axios";
import Bus from "../../bus";
import moment from 'moment';
import zigZag from '../../components/ZigZag';

export default {
  name: "Create Batch",

  components: {
    Spinner,
    zigZag
  },

  data: () => ({
    dialog: false,
    valid: true,
    ddlBatchType: [],
    ddlBatchDescription:[],
 
    requiredRules: [v => !!v || "Required"],
    isBatchDescriptionDisabled:false,
  
    resolve: null,
    reject: null,
    batch:{},
  }),

  mounted() {
    this.initialize();
  },

  methods: {
    initialize () {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async open() {
      this.dialog = true;
     
this.getDropDownLists()

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    getDropDownLists(){
      axios.get("api/Receivables/GetCreateNewBatchDDL").then(res => {
        this.ddlBatchType = res.data.ddlBatchType
      })
    },
    getBatchDescription(val){
      if (val){
        this.batch.description= null
        axios.get("api/Receivables/GetBatchDescriptionDLL/"+val).then(res => {
        this.ddlBatchDescription = res.data.ddlBatchDescription
      })
      }
    },
    async createBatch() {
      if (this.$refs.createBatchForm.validate()) {
      var result = await axios.post("api/Receivables/CreateBatch", this.batch)
      .then(res => { Bus.$emit("alert", {
            color: "success",
            message: "New Batch Created Successfully"
          });
          this.close(res.data)});
      }
      
    },
    isOpen(){
      return this.dialog
    },

    

    cancel() {
     this.batch ={},
      this.dialog = false;
      this.resolve(false)
      

      // this.resetFormFilters()
    },
    close(item){
      this.batch ={},
      this.dialog = false;
this.resolve(item)
      this.$root.$emit("initialize", this.initialize);
    },

  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

